<!--
 * @Description: 修改备注名称
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-05 09:57:25
 -->

<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
            添加备注
        </v-card-title>
        <p></p>
        <v-card-text>
            <v-text-field label="患者备注" maxlength="10" outlined color="black" v-model.trim="value"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">取消</v-btn>
          <v-btn color="green darken-1" text @click="tag_name"> 备注 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      value: '',
      data: {}
    };
  },
  methods: {
    info(state, data) {
      this.dialog = state;
      this.data = data;
      this.value = data.tag_name;
      window.console.log( data )
    },
    /* 修改备注 */ 
    tag_name(){
        // user_label
        if( this.value == '' ){
            this.$Dialog.getProductCheckResult_({ text: `请输入患者备注`, timeout: 1500, snackbar: true });
            return false;
        }
        this.$axios({
            method: "post",
            url: this.$apis.URL.user_label,
            data: {
                "tag_name": this.value,
                "user_id": this.data.id
            }
        })
        .then(req => {
          if (req.data.result == 0) {
            this.$Dialog.getProductCheckResult_({ text: `患者备注名已变更`, timeout: 3000, snackbar: true });
            this.dialog = false;
            this.$parent.remarks_name(this.value);
          } else {
            this.$Dialog.getProductCheckResult_({ text: req.data.message, timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({ text: error, timeout: 3000, snackbar: true });
        });
    }
  }
};
</script>

<style>
</style>